import { useState, useCallback, useEffect } from 'react';
import { message } from 'antd';
import { t402Api } from '../../../services/t402Api';
import { FT121 } from '../../../services/t102Api';
import dayjs from 'dayjs';

export function useAnnouncementQuery() {
  const [loading, setLoading] = useState(false);
  const [records, setRecords] = useState<FT121[]>([]);
  const [total, setTotal] = useState(0);
  const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day'));
  const [endDate, setEndDate] = useState(dayjs());

  const doQuery = useCallback(async (start: dayjs.Dayjs, end: dayjs.Dayjs) => {
    setLoading(true);
    try {
      const res = await t402Api.query(
        start.format('YYYY-MM-DD'),
        end.format('YYYY-MM-DD'),
        1,
        1000
      );
      setRecords(res.data || []);
      setTotal(res.total || 0);
    } catch {
      message.error('查詢失敗');
      setRecords([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, []);

  // BR-I01: Auto-query on form load with default date range (past 7 days)
  useEffect(() => {
    doQuery(startDate, endDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleQuery = () => {
    doQuery(startDate, endDate);
  };

  return {
    loading,
    records,
    total,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    handleQuery,
  };
}
